module.exports = window["MaterialUI"].Select;